var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-2xl text-center mb-3 md:mb-0 md:mr-3"},[_c('span',{staticClass:"t"},[_vm._v(_vm._s(_vm.text)+" ")]),_c('span',{staticClass:"b blue block lg:inline-block"},[_vm._v(_vm._s(_vm.textBold))])])}
var staticRenderFns = []

export { render, staticRenderFns }